const _import_ = file => () => import('../pages/' + file + '.vue')
import Main from "./Main.js";

/*
 slide: 页面切换动画
 login: 是否需要登陆

 */
const router = [
  {
    path: '/login',
    name: '登录',
    hidden: true,
    component: _import_('Login/index'),
  },
  ...Main
];

export default router;



// WEBPACK FOOTER //
// ./src/router/routers.js